export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  return emailRegex.test(email);
};
